import React from "react";
import { Disqus as DisqusPlugin } from "gatsby-plugin-disqus";
import urljoin from "url-join";

function Disqus({ article }) {
  let title = article.title.replace(/-|\s/g,"-");
  let url = urljoin("https://machinatl.netlify.app", title);
  return (
    <DisqusPlugin
      config={{
        url,
        identifier: article.title,
        title: article.title,
      }}
    />
  );
}

export default Disqus;